import { render, staticRenderFns } from "./BankInfo.vue?vue&type=template&id=3c72a29e&scoped=true"
import script from "./BankInfo.vue?vue&type=script&lang=js"
export * from "./BankInfo.vue?vue&type=script&lang=js"
import style0 from "./BankInfo.vue?vue&type=style&index=0&id=3c72a29e&prod&lang=scss&scoped=true"
import style1 from "./BankInfo.vue?vue&type=style&index=1&id=3c72a29e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c72a29e",
  null
  
)

export default component.exports